<template>
  <div>

    <div class="demo-upload-list" v-for="item in uploadList">

      <template v-if="item.status === 'finished'">
        <Icon type="ios-backspace-outline" @click.native="handleRemove(item)"></Icon>
        <viewer :images="item | formateUrlArr" class="pics">
          <img :src="item | formateUrl">
        </viewer>
        <!-- <div class="demo-upload-list-cover">
	               <Icon type="ios-eye-outline" @click.native="handleView(item.name)"></Icon>
	               <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
	           </div> -->
      </template>
      <template v-else>
        <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
      </template>
    </div>

    <Upload v-show='maxLen > uploadList.length' ref="upload" :show-upload-list="false" :default-file-list="defaultList"
      :on-success="handleSuccess" :format="['jpg', 'jpeg', 'png']" :max-size="20480" :on-format-error="handleFormatError"
      :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" :data="extradata" multiple type="drag"
      :action="actionUrl" style="display: inline-block;width:58px;">
      <div style="width: 58px;height:58px;line-height: 58px;">
        <Icon type="ios-camera" size="20"></Icon>
      </div>
    </Upload>
    <!-- <Modal title="View Image" v-model="visible">
	       <img :src="'https://o5wwk8baw.qnssl.com/' + imgName + '/large'" v-if="visible" style="width: 100%">
         http://display.incich.com:9208/UploadImageServlet?ispress=1&thum=1&maxW=1920&maxH=1080&notkeeppic=1
	   </Modal> -->
  </div>
</template>
<script>
export default {
  name: 'upImg',
  watch: {

    defaultimg: function (newval, oldval) {

      // if(newval&&newval!='' && typeof(newval)!='number'){
      // if(typeof(newval)!='number'){
      if (newval && newval != '' && typeof (newval) != 'number') {
        var arr = newval.split(",")
        var newarr = []
        for (var i = 0; i < arr.length; i++) {
          var ojb = {
            percentage: 100,
            showProgress: false,
            status: 'finished',
            response: {
              url: arr[i] + '@' + arr[i]
            }
          }
          newarr.push(ojb)
        }

        this.$refs.upload.fileList = this.uploadList = newarr


      } else if (newval == '' || typeof (newval) == 'number') {
        this.$refs.upload.fileList = this.uploadList = []
      }

    }
  },
  props: {
    maxLen: {
      type: Number,
      default: 1
    },
    defaultimg: {
      default: '',
    },
    extradata: {
      type: Object,
      default: {},
    },
    defaultname: {
      type: String,
      default: '',
    },
    defaultImgList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      defaultList: [
      ],
      imgName: '',
      visible: false,
      uploadList: [],
      actionUrl: '',
    }
  },
  methods: {
    handleView (name) {
      this.imgName = name;
      this.visible = true;
    },
    handleRemove (file) {
      const fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);


      this.$emit('upImglist', { pics: this.uploadList, name: this.defaultname, state: 'remove' })
    },
    handleSuccess (res, file) {

      this.$forceUpdate()
      this.$emit('upImglist', { pics: this.uploadList, name: this.defaultname })
    },
    handleFormatError (file) {
      this.$Notice.warning({
        title: '图片格式不正确',
        desc: '图片' + file.name + ' 格式不正确.'
      });
    },
    handleMaxSize (file) {
      this.$Notice.warning({
        title: 'Exceeding file size limit',
        desc: 'File  ' + file.name + ' is too large, no more than 2M.'
      });
    },
    handleBeforeUpload () {

      const check = this.uploadList.length < this.maxLen;
      if (!check) {
        this.$Notice.warning({
          title: '不能超过' + this.maxLen + '张图片'
        });
      }
      return check;
    }
  },
  mounted () {
    this.uploadList = this.$refs.upload.fileList;
    this.actionUrl = 'http://180.103.125.157:9987/UploadImageServlet' || this.baseURL.imgURL


  },
  filters: {
    formateUrl (val, flag) {

      var item = val.response.url
      return item.split("@")[0]
    },
    formateUrlArr (val) {

      var item = val.response.url
      var arr = []
      arr.push(item.split("@")[0])

      return arr


    }
  }
}
</script>
<style scoped>
.demo-upload-list {

  display: inline-block;
  /*  width: 60px;
        height: 60px; */
  text-align: center;
  /*  line-height: 60px; */
  /*  border: 1px solid transparent; */
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
  margin-right: 4px;
  overflow: hidden;
}

.demo-upload-list .pics {
  width: 100%;
  height: 100%;
}

.demo-upload-list img {
  width: 80px;
  height: 60px;

  float: left;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}

.demo-upload-list .ivu-icon {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 0 0 0 16px;
  color: #fff;
  cursor: pointer;
}
</style>
